import { Grid } from "@mui/material";
import CancelOutlined from "@mui/icons-material/CancelOutlined";

export const SelectedUsersPreview = ({ data, labelKey, setSelectedData }) => {
  const handleCancelSelection = (index) => {
    const tempData = data.filter((_, auxIndex) => index !== auxIndex);
    setSelectedData(tempData);
  };

  return (
    <Grid container gap={1} marginTop="1rem" direction="column">
      {data.map((row, index) => {
        return (
          <Grid xs item key={row[labelKey]}>
            <p
              className="subHeading-secondary"
              style={{ fontSize: "1.3rem", color: "#818181" }}
            >
              <CancelOutlined
                onClick={() => handleCancelSelection(index)}
                className="text-colors__primary-color-one"
                style={{
                  marginRight: "1.5rem",
                  fontSize: "2rem",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
              />

              {row[labelKey]}
            </p>
          </Grid>
        );
      })}
    </Grid>
  );
};
